module.exports = __webpack_public_path__ + "img/cargos.c4a72397.png";